import script from "./LazyBackgroundMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./LazyBackgroundMedia.vue?vue&type=script&lang=ts&setup=true"

import "./LazyBackgroundMedia.vue?vue&type=style&index=0&id=a6958cb2&lang=scss"

const __exports__ = script;

export default __exports__